<template>
  <div v-if="activeDeliveryTypeId === 'PICK_POINT'">
    <!-- Список и карта ПВЗ, когда нет выбранного пикпоинта -->
    <div v-if="!isPpSelected && !loading.main" class="flex flex-col">
      <div class="relative" v-if="isPickpointsInCity">
        <GodModal
          v-if="showPickpointInfoModal && activePickpoint"
          :title="activePickpoint.deliveryCompanyName || ''"
          height="auto !important"
          :width="$isMobile ? '95%' : '480px'"
          window-class="pb-2"
          :main-content-padding="
            $isMobile ? '1rem 1rem 0 1rem' : '2rem 2rem 0 2rem'
          "
          overlay
          close-on-overlay-click
          close-on-button-click
          :callback-functions="{ mainButton: 'select-pickpoint' }"
          :button-names="{ mainButton: $t('choose_button') }"
          :button-classes="{ mainButton: ['w-full'] }"
          @select-pickpoint="onSelectPickpoint(activePickpoint)"
          @close-position-modal="onClosePickpointInfoModal"
          @close-modal="onClosePickpointInfoModal"
        >
          <div class="px-4 lg:px-8">
            <div class="mt-1">
              <h4
                class="text-lg font-medium"
                v-html="activePickpointAddressModal(activePickpoint)"
              />
            </div>
            <div class="mt-3" v-if="activePickpoint.WORKTIME">
              <span v-html="activePickpoint.WORKTIME" />
            </div>
            <div class="mt-2" v-if="activePickpoint.paymentSystems?.length">
              <span class="font-medium">{{ $t('payment_methods') }}:</span>
              <span
                v-for="(ps, idx) in activePickpoint.paymentSystems"
                :key="ps.ID"
              >
                {{ ps.NAME
                }}<span v-if="idx + 1 < activePickpoint.paymentSystems.length"
                  >,
                </span>
              </span>
            </div>
          </div>
        </GodModal>

        <!-- Карта с ПВЗ -->
        <GoogleMap
          v-if="!loading.map && activePickpointsTemplate === 'map'"
          data-qa="step4-google-map"
          :styles="$isMobile ? 'width:100%;height:90vw;' : 'width:100%'"
          map-click-function="close-pickpoint-info-window"
          :initial-markers="getAllPickpoints"
          :filter-markers-by-city="addressInfo.PROFILE.CITY"
          :zoom-to-cords="zoomToCordsObj"
          :center-map-to-coords="centerMapCoords"
          :initial-zoom="11"
          :map-options="mapOptions"
          :get-address-on-click="false"
          :active-pickpoint="activePickpoint"
          @show-pickpoint-info="onShowPickpointInfo"
          @close-pickpoint-info-window="onClosePickpointInfoModal"
        />
      </div>

      <!-- Карточка активного ПВЗ под картой -->
      <div
        class="pt-8 flex flex-row items-center flex-wrap lg:flex-row"
        v-if="activePickpoint && !isPpSelected"
      >
        <div class="flex flex-col w-full mb-3 lg:w-1/2 lg:mb-0">
          <h3 class="text-base font-bold">
            {{ getDeliveryCompanyInfo(activePickpoint.TYPE).name }}
          </h3>
          <span>
            {{
              activePickpoint.CITY &&
              !activePickpoint.ADDRESS.includes(activePickpoint.CITY) &&
              activePickpoint.TYPE !== 'I_UA_NEW_POST'
                ? activePickpoint.CITY + ','
                : ''
            }}
            {{ activePickpoint.ADDRESS.replace(/<\/?[^>]+(>|$)/g, ' ') }}
          </span>
        </div>
        <h3 class="font-bold text-base lg:pl-6 w-1/2 lg:w-1/4">
          {{ formatMoney(getDeliveryCompanyInfo(activePickpoint.TYPE).price) }}
        </h3>
        <div class="flex w-1/2 lg:w-1/4">
          <a
            class="checkout-button ml-auto focus:outline-none h-[44px]"
            @click="onSelectPickpoint(activePickpoint)"
            data-qa="step4-active-pickpoint-choose-btn"
          >
            {{ $t('choose_button') }}
          </a>
        </div>
      </div>

      <!-- Список ПВЗ -->
      <div
        class="flex flex-col scrollWindow"
        v-if="activePickpointsTemplate === 'list' && isPickpointsInCity"
        @scroll="onShowMorePickpoints"
      >
        <div
          v-for="pp in getAllPickpoints.slice(0, itemsToShow)"
          :key="pp.idx"
          class="py-4 border-b border-gray-300 flex flex-row items-center flex-wrap lg:flex-row"
          :data-qa="'step4-pickpoint-item-' + pp.idx"
        >
          <div class="flex flex-col w-full mb-3 lg:w-1/2 lg:mb-0">
            <h3 class="text-base font-bold">
              {{ getDeliveryCompanyInfo(pp.TYPE).name }}
            </h3>
            <span>
              {{ getPickPointAddress(pp, store.getters.getCountryCode) }}
            </span>
          </div>
          <h3 class="font-bold text-base lg:pl-6 w-1/2 lg:w-1/4">
            {{ formatMoney(getDeliveryCompanyInfo(pp.TYPE).price) }}
          </h3>
          <div class="flex w-1/2 lg:w-1/4">
            <a
              class="checkout-button ml-auto focus:outline-none h-[44px]"
              @click="onSelectPickpoint(pp)"
              data-qa="step4-pickpoint-choose-btn"
            >
              {{ $t('choose_button') }}
            </a>
          </div>
        </div>
      </div>

      <SkeletonPickpoints v-if="!isPickpointsInCity && loading.pickpoints" />
    </div>

    <!-- Детали уже выбранной точки -->
    <div v-if="isPpSelected" class="flex flex-col">
      <div class="rounded border p-4 lg:p-8">
        <h3 class="text-xl font-bold">
          {{ $t('selected_pickpoint_title') }}
          {{ selectedPickpointInfo.deliveryCompanyName }}
        </h3>
        <div class="mt-4">
          <h4 class="text-lg font-bold">
            {{
              selectedPickpointInfo.CITY &&
              !selectedPickpointInfo.ADDRESS.includes(
                selectedPickpointInfo.CITY
              ) &&
              selectedPickpointInfo.TYPE !== 'I_UA_NEW_POST'
                ? selectedPickpointInfo.CITY + ','
                : ''
            }}
            {{ selectedPickpointInfo.ADDRESS.replace(/<\/?[^>]+(>|$)/g, ' ') }}
          </h4>
        </div>
        <div class="mt-4" v-if="selectedPickpointInfo.WORKTIME">
          <h5 class="text-md font-bold">
            {{ $t('selected_pickpoint_worktime') }}:
          </h5>
          <p class="mt-2" v-html="selectedPickpointInfo.WORKTIME" />
        </div>
        <div class="mt-4" v-if="selectedPickpointInfo.NOTE">
          <h5 class="text-md font-bold">
            {{ $t('selected_pickpoint_note') }}:
          </h5>
          <p class="mt-2">
            {{ selectedPickpointInfo.NOTE.replace(/<\/?[^>]+(>|$)/g, ' ') }}
          </p>
        </div>
        <div class="mt-4" v-if="selectedPickpointInfo.price">
          <h5 class="text-md font-bold">
            {{ $t('selected_pickpoint_price') }}:
          </h5>
          <p class="mt-2">{{ formatMoney(selectedPickpointInfo.price) }}</p>
        </div>
        <div
          class="mt-4"
          v-if="selectedPickpointInfo.PHONE || selectedPickpointInfo.EMAIL"
        >
          <h5 class="text-md font-bold">
            {{ $t('selected_pickpoint_contacts') }}:
          </h5>
          <p class="mt-2" v-if="selectedPickpointInfo.PHONE">
            {{ $t('selected_pickpoint_contacts_phone') }}:
            {{ selectedPickpointInfo.PHONE }}
          </p>
          <p v-if="selectedPickpointInfo.EMAIL">
            {{ $t('selected_pickpoint_contacts_email') }}:
            {{ selectedPickpointInfo.EMAIL }}
          </p>
        </div>
        <Notification
          v-if="
            selectedPickpointInfo.TYPE === 'I_PICKUP' && needToShowNotification
          "
          class="mt-3"
          :text="$t('i_pickup_get_order_notification')"
        />
        <button
          class="checkout-button mt-6 bg-accentColor text-white p-3 w-full border-2 border-accentColor focus:outline-none lg:w-1/3"
          @click="onSelectPickpoint(undefined)"
          data-qa="step4-pickpoint-change-btn"
        >
          {{ $t('selected_pickpoint_change_button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue'
import GodModal from '@/components/GodModal.vue'
import GoogleMap from '@/components/address/Map.vue'
import Notification from '@/components/Notification.vue'
import SkeletonPickpoints from './SkeletonPickpoints.vue'
import { useStore } from 'vuex'
import { getPickPointAddress } from '@/utils/pickpoints'
import { perfPoint } from '@/utils/perfMarks'

const store = useStore()

const props = defineProps({
  loading: { type: Object, required: true },
  activeDeliveryTypeId: { type: String, required: true },
  selectedPickpointInfo: { type: Object, default: () => ({}) },
  activePickpoint: { type: Object, default: () => ({}) },
  showPickpointInfoModal: { type: Boolean, required: true },

  activePickpointsTemplate: { type: String, required: true },
  getAllPickpoints: { type: Array || undefined, required: true },
  addressInfo: { type: Object, required: true },
  zoomToCordsObj: { type: Object, required: true },
  googleObject: { type: Object, required: true },
  mapOptions: { type: Object, required: true },
  itemsToShow: { type: Number, required: true },
  // утилиты из родителя
  formatMoney: { type: Function, required: true },
  getDeliveryCompanyInfo: { type: Function, required: true },
  activePickpointAddressModal: { type: Function, required: true },
})

const isPickpointsInCity = computed(() => props.getAllPickpoints?.length > 0)

onMounted(() => {
  if (isPickpointsInCity.value) perfPoint('ui:pickpoints-visible')
})
watch(isPickpointsInCity, (visible) => {
  if (visible) perfPoint('ui:pickpoints-visible')
})
const centerMapCoords = computed(() => {
  const location = props.googleObject?.geometry?.location
  return location
    ? {
        lat: location.lat(),
        lng: location.lng(),
      }
    : null
})

const isPpSelected = computed(
  () => Object.keys(props.selectedPickpointInfo).length > 0
)

const needToShowNotification = computed(
  () => store.getters.needToShowNotification
)

const emit = defineEmits([
  'selectPickpoint',
  'showPickpointInfo',
  'closePickpointInfoModal',
  'showMorePickpoints',
])

function onSelectPickpoint(pickpoint) {
  emit('selectPickpoint', pickpoint)
}
function onShowPickpointInfo(pickpoint) {
  emit('showPickpointInfo', pickpoint)
}
function onClosePickpointInfoModal() {
  emit('closePickpointInfoModal')
}
function onShowMorePickpoints(event) {
  emit('showMorePickpoints', event)
}
</script>
